import { zendeskRequestUrl } from 'utils/zendeskRequest';

/**
 * The Zendesk form a buyer is sent to instead of cancelling a job themselves (PRD-416).
 *
 * Buyers never cancel in RevShop: the form asks why they are cancelling, the ticket reaches a CSR,
 * and the CSR runs the sourcer-side cancellation that already exists. So the form is the whole
 * buyer-facing step -- nothing about the job changes when the button is clicked.
 */
const CANCEL_JOB_REQUEST_FORM_ID = '49492870405517';

/**
 * The cancel-request form, with the job and the org it came from written into the subject and the
 * job into the body, so the ticket says what it is about before anyone opens it.
 *
 * The job number is the one printed on the card, revision included -- the buyer and the CSR should
 * be quoting the same number at each other. The org is dropped from the subject rather than left
 * as an empty tail when the session has no name for it.
 */
export const getCancelJobRequestUrl = (
  jobId: number | string,
  orgName?: string
): string =>
  zendeskRequestUrl({
    ticket_form_id: CANCEL_JOB_REQUEST_FORM_ID,
    tf_subject: orgName
      ? `Request to cancel job ${jobId} from ${orgName}`
      : `Request to cancel job ${jobId}`,
    tf_description: `I would like to cancel job ${jobId}`,
  });
